import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import { Box, Typography } from '@mui/material'
import { LuX } from 'react-icons/lu'

import Icon from '@/components/Icon'

function BrandValue({
  value,
  expanded,
  setExpanded,
  setTooltipOpen,
}: {
  value: string
  expanded: boolean
  setExpanded: any
  setTooltipOpen: (open: boolean) => void
}) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1.5}
    >
      <Typography
        sx={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          maxWidth: '100%',
        }}
      >
        <Box
          bgcolor="rgba(33, 33, 33, 0.80)"
          fontSize="12px"
          lineHeight="20px"
          letterSpacing="0.25"
          px="6px"
          py="2px"
          borderRadius="4px"
          width="fit-content"
          whiteSpace="nowrap"
        >
          {value}
        </Box>
      </Typography>
      {!expanded && (
        <Box display="flex" alignItems="center" gap={1}>
          <Icon icon={LuX} size={18} onClick={() => setTooltipOpen(false)} />
          <OpenInFullIcon
            onClick={() => setExpanded((prev: any) => !prev)}
            sx={{ height: 16, width: 16, cursor: 'pointer' }}
          />
        </Box>
      )}
    </Box>
  )
}

export default BrandValue
